import { Link, useParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { CTASection } from "../components/site/CTASection";
import { getExpertise, EXPERTISE } from "../data/expertise";
import NotFound from "./NotFound";

export default function ExpertiseDetail() {
  const { slug } = useParams();
  const e = getExpertise(slug);
  if (!e) return <NotFound />;

  return (
    <div>
      <PageHero
        variant="light"
        label="Expertise"
        title={e.title}
        intro={e.lead}
        crumbs={[{ label: "Expertise", to: "/expertise" }, { label: e.title }]}
      />

      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[2fr_1fr]">
          <div>
            <SectionLabel>Where we add value</SectionLabel>
            <div className="grid gap-px border border-brand-line bg-brand-line sm:grid-cols-2">
              {e.points.map((p) => (
                <div key={p} className="flex items-start gap-3 bg-white p-5">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-blue" />
                  <span className="text-[15px] text-brand-ink/85">{p}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 border border-brand-blue/20 bg-brand-blue/5 p-6">
              <h3 className="font-heading text-lg font-bold text-brand-ink">Technical Intelligence</h3>
              <p className="mt-2 text-sm text-brand-muted">
                Explore the practical knowledge base and calculators connected to this expertise.
              </p>
              <Link
                to={e.technicalLink}
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue hover:gap-2.5"
              >
                Go to Technical Hub <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>

          <aside className="space-y-8 lg:sticky lg:top-24 lg:self-start">
            <div className="border border-brand-line bg-white p-6">
              <SectionLabel>Related advisory</SectionLabel>
              <Link
                to="/advisory/industrial-advisory"
                className="group flex items-start gap-2 text-sm font-medium text-brand-ink hover:text-brand-blue"
              >
                <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" /> Industrial & Chemical Advisory
              </Link>
            </div>
            <div className="border border-brand-line bg-white p-6">
              <SectionLabel>All expertise</SectionLabel>
              <ul className="space-y-2">
                {EXPERTISE.map((r) => (
                  <li key={r.slug}>
                    <Link
                      to={`/expertise/${r.slug}`}
                      className={`text-sm ${r.slug === slug ? "font-semibold text-brand-blue" : "text-brand-muted hover:text-brand-ink"}`}
                    >
                      {r.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>

      <CTASection />
    </div>
  );
}
